import { TipoControladorSenha } from "@/utils/controladores"

export const filters = {
  tipoToString(tipo) {
    return Object.values(TipoControladorSenha).find(t => t.id === tipo).name
  }
}
